import { supabase } from '@/lib/supabase';

export interface StripeInvoice {
  id:                 string;
  number:             string | null;
  status:             string | null;   // 'paid' | 'open' | 'void' | 'uncollectible'
  amount_paid:        number;          // cents
  amount_due:         number;          // cents
  currency:           string;          // 'brl' | 'usd' …
  created:            number;          // unix timestamp
  period_start:       number;          // unix timestamp
  period_end:         number;          // unix timestamp
  hosted_invoice_url: string | null;   // Stripe-hosted HTML invoice
  invoice_pdf:        string | null;   // direct PDF link
  // Expanded from the associated charge
  card_brand:         string | null;
  card_last4:         string | null;
  failure_message:    string | null;
}

async function invoke<T>(fnName: string): Promise<T> {
  const { data, error } = await supabase.functions.invoke(fnName, { body: {} });
  if (error) throw new Error(error.message ?? 'Function error');
  if (data?.error) throw new Error(data.error);
  return data as T;
}

export const invoiceApi = {
  list(): Promise<{ invoices: StripeInvoice[] }> {
    return invoke('stripe-list-invoices');
  },
};
